webpackJsonp([144941519247333],{

/***/ 1350:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":null,"authorJson":{"name":"Hannah Lorence","slug":"blog/author/hannah-lorence","twitter":"hannitachula","linkedIn":null,"website":"https://www.linkedin.com/in/hannahlorence","biography":"Hannah is an Online Marketing Specialist and Freelance Writer who has managed blogs and website content for a variety of clients. She loves to help small and large brands tell their story. Growing up in Texas, she considers herself a Southern girl at heart, but still loves rainy Seattle. You can find her curled up with a good cup of coffee and a book when she’s not throwing sticks for her puppy at the park.","image":{"fields":{"description":"blog-author-hannah-lorence.jpg","file":{"url":"//images.ctfassets.net/k428n7s2pxlu/1zfPsnlpXic84YgwmSoOKK/9bbcd3730541f066794ba77a8fd32828/blog-author-hannah-lorence.jpg"}}}}},"pathContext":{"slug":"blog/author/hannah-lorence"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-hannah-lorence-a698be06d4994572d798.js